// Get templates from backend

export default {
  GET_CETIFICATE_TEMPLATE_LIST (state, payload) {
   
    state.template_list = payload.data.certificate_template_list
    state.templateListMetaData = payload.data.meta
  },

  GET_CETIFICATE_DYNAMIC_TEXTS (state, payload) {
    payload.data.certificate_dynamic_field.map((dynamicText) => {
      let field_name = dynamicText.field_name
      let field_code = dynamicText.field_code

      if (field_name === 'Name of Staff Recipient') field_name = 'Staff Name'
      if (field_name === 'Name of Course Teacher') return
      if (field_name === 'Class Teacher Name') return
      if (field_name === 'Name of Course') field_name = 'Course Name'
      if (field_name === 'Name of Client Recipient') {
        field_name = 'Student Name'
        field_code = '{student_name}'
      }

      state.dynamicTextList.push({
        ...dynamicText,
        field_code,
        field_name
      })
    })

  },

  GET_STUDENTS_LIST (state, payload) {
    state.studentList = payload.data.studentlist
  },

  GET_TEACHERS_LIST (state, payload) {
    state.teacherList = payload.data.teacherlist
  },

  GET_CLASS_LIST (state, payload) {
    state.classList = payload.data.classes
    state.classListMetaData = payload.data.meta
  },

  GET_CLASS_DETAIL (state, payload) {
    state.classDetail = payload.data.classes
  },

  GET_COURSE_LIST (state, payload) {
    state.courseList = payload.data.course
  }
}
